// ============ Channel Data Selectors ============
export const selectAllChannels = (state) => state.channel.allChannels;
export const selectChannels = (state) => state.channel.channels;

// ============ UI State Selectors ============
export const selectArchiveFilter = (state) => state.channel.archiveFilter;
export const selectShowUnlinkedCount = (state) => state.channel.showUnlinkedCount;
export const selectChannelPanelOpen = (state) => state.channel.channelPanelOpen;
export const selectFullscreenImage = (state) => state.channel.fullscreenImage;
export const selectActiveThreadParentId = (state) => state.channel.activeThreadParentId;

// ============ Loading State Selectors ============
export const selectIsChannelsLoading = (state) => state.channel.isChannelsLoading;

// ============ Derived Selectors ============

/**
 * Get channel by ID
 */
export const selectChannelById = (state, channelId) => {
    if (!channelId) return null;
    return state.channel.channels.find(ch => ch.id === parseInt(channelId)) || null;
};
